export default __webpack_public_path__ + "static/media/outlet-avatar.64e6d825.png";